import { z } from 'zod'

export const changePasswordSchema = z
  .object({
    oldPassword: z.string().min(8).max(70),
    newPassword: z.string().min(8).max(70),
    newPasswordRepeat: z.string().min(8).max(70)
  })
  .refine(data => data.newPassword === data.newPasswordRepeat, {
    message: 'New passwords must match',
    path: ['newPasswordRepeat']
  })

export const requestResetPasswordSchema = z.object({
  email: z.email().max(256)
})

export const resetPasswordPayloadSchema = z
  .object({
    token: z.string(),
    password: z
      .string()
      .min(8, 'min_length')
      .max(70, 'max_length')
      .regex(/[A-Z]/, 'one_uppercase_letter')
      .regex(/[\W_]/, 'one_special_char'),
    confirmPassword: z.string()
  })
  .refine(data => data.password === data.confirmPassword, {
    message: 'passwords_do_not_match',
    path: ['confirmPassword']
  })

export type UserChangePasswordPayload = z.infer<typeof changePasswordSchema>

export type OperatorOrganization = {
  id: string
  name: string
  localName: string
  activatedAt: string | null
  isMandatoryInfoComplete: boolean
  certificateFileName: string | null
  businessRegistrationNumber: string | null
  placeOfRegistration: string | null
  maxNumberInstallations: number
  street: string
  street2: string
  city: string
  postCode: string
  country: string
  streetNumber: string
  subDivision: string
  poBox: string
  contactName: string
  contactEmail: string
  contactPhoneNumber: string
  localStreet: string
  localStreet2: string
  localStreetNumber: string
  localSubDivision: string
  localPostCode: string
  localPoBox: string
  localCity: string
}

export type OperatorUserSession = {
  id: string
  email: string
  firstName: string
  lastName: string
  isEmailVerified: boolean
  organization: OperatorOrganization
  language: string
  permissions: string[]
  passwordResetRequired: boolean
}
